import type {ViewableExemplar} from 'typings/portaro.be.types';
import type {Component} from 'typings/portaro.fe.types';

interface KpSelectableExemplarCardComponentBinding {
    exemplar: ViewableExemplar;
    isSelected: boolean;
}

/**
 * @ngdoc component
 * @name kpSelectableExemplarCard
 * @module uc.record
 *
 * @param {ViewableExemplar} exemplar
 * @param {boolean} isSelected
 *
 * @description
 *
 */
export class KpSelectableExemplarCardComponent implements Component<KpSelectableExemplarCardComponentBinding>{
    public static readonly componentName = 'kpSelectableExemplarCard';

    public bindings = {
        exemplar: '<',
        isSelected: '<'
    } as const;

    public templateUrl = require('./kp-selectable-exemplar-card.tpl.ftl');
    public styleUrls = [require('./kp-selectable-exemplar-card.less')];
    public controller = KpSelectableExemplarCardComponentController;
}

class KpSelectableExemplarCardComponentController implements KpSelectableExemplarCardComponentBinding {
    exemplar: ViewableExemplar;
    isSelected: boolean;

    public isAvailable(): boolean {
        return this.exemplar.availability?.free
    }

    public isNotAvailable(): boolean {
        return this.isLent() || (this.isError() && !this.isFreeOrReservable())

    }

    private isFreeOrReservable(): boolean {
        return this.exemplar.availability?.free || this.exemplar.availability?.reservable;
    }

    private isLent(): boolean {
        return this.exemplar.availability?.lent;
    }

    private isError(): boolean {
        return this.exemplar.availability?.error;
    }
}